import React, { Component } from 'react'
import { Row, Col, Input, Modal, Select } from 'antd';
import $ from 'jquery';
import _ from 'underscore';
import dates_year from './../../../dates';

const Option = Select.Option;
class NewWeekend extends Component {

    constructor( props ){

        super( props );

        this.state = {
            visible          : false,
            company_id       : '',
            holiday_dates    : [],
            holiday_name     : 'none',
            holiday_type     : 'weekend',
        }

        this.clcWeekendDates = this.clcWeekendDates.bind( this );

    }

    clcWeekendDates(){
        let dates = [];
        _.map( dates_year.date, ( item, key )=> {
            let d = new Date( item );
            let pred = new Date( d.getFullYear(), d.getMonth()+1, 0 ).getDate();
            let nowd;let i;
            for ( i=1; i<=pred; i++ ) {
                try {
                    nowd = new Date(d.getFullYear()+ "-" + (d.getMonth()+1) + "-" + i)
                    let dd = new Date(nowd);
                    let m = dd.getMonth()+1;
                    let y = dd.getFullYear();
                    _.map( this.state.holiday_dates, ( value,  j ) => {
                        if ( nowd.getUTCDay() == parseInt(value) ){
                            dates.push( y+'-'+m+'-'+i );
                        }
                    });
                } catch(e) {
                    return;
                }
            }
        });
    }

    handleOk = (e) => {
        
        if( this.state.company_id === "" || this.state.company_id === "none" && 
            this.state.holiday_name === "" || this.state.holiday_name === "none" &&
            this.state.holiday_dates !== 0 ){
            
            this.setState({
                company_id: '',
                holiday_name: ''
            });

            return false;
        
        }

        this.props.onSubmit( this.state );
        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    componentWillReceiveProps( nextProps ){
        // Clear Input
        $('input').val( '' );
        
        this.setState({
            visible: nextProps.onModel
        });
    
    }

    render() {

        let compay_list = this.props.company_data.map( ( item, i ) => <Option key={ item.company_id }>{ item.company_name }</Option> )

        return (
            <Modal
                title="New Weekend"
                maskClosable={false}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        
                        <label className={ ( this.state.compay_id === '' ) ? 'error': '' }>Select Company</label>
                        
                        <Select 
                            className={ ( this.state.compay_id === '') ? 'br_error': '' }
                            onChange={ ( value )=> this.setState({ company_id: value }) }
                            style={{ width: '100%' }} >
                            { compay_list }
                        </Select>

                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.holiday_name === '') ? 'error': '' }>Holiday Name</label>
                        <Input 
                            className={ ( this.state.holiday_name === '') ? 'br_error': '' } 
                            onChange={ (e)=> this.setState({ holiday_name: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Select Weekends</label>
                        <Select 
                            mode="multiple"
                            style={{ width: '100%' }}
                            onChange={ ( value ) => this.setState({ holiday_dates: value }) } 
                            >
                            <Option key="Mon">Monday</Option>
                            <Option key="Ths">Tuesday</Option>
                            <Option key="Wed">Wednesday</Option>
                            <Option key="Thu">Thursday</Option>
                            <Option key="Fri">Friday</Option>
                            <Option key="Sat">Saturday</Option>
                            <Option key="Sun">Sunday</Option>
                        </Select>
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default NewWeekend


// WEBPACK FOOTER //
// ./src/pages/holidays/childs/new.weekend.js